module.exports = __webpack_public_path__ + "img/under-maintenance.a2f49579.svg";